export enum EntityType {
  Actor = 'actor',
  Model3d = 'models_3d',
  PhysicsBody = 'physics_body',
  Space = 'space'
}
